<template>
  <svg class="checkmark-icon" width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7071 0.292893C13.0976 0.683418 13.0976 1.31658 12.7071 1.70711L5.37377 9.04044C4.98325 9.43096 4.35008 9.43096 3.95956 9.04044L0.292893 5.37377C-0.0976311 4.98325 -0.0976311 4.35008 0.292893 3.95956C0.683417 3.56904 1.31658 3.56904 1.70711 3.95956L4.66667 6.91912L11.2929 0.292893C11.6834 -0.0976311 12.3166 -0.0976311 12.7071 0.292893Z"/>
  </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.checkmark-icon {
  path {
    fill: var(--primary-text);
  }
}
</style>
